import { Component } from '@angular/core';

@Component({
	selector: 'app-post-out',
	templateUrl: './post-out.component.html',
	styleUrls: ['./post-out.component.css'],
})
export class PostOutComponent {
	constructor() {}
}
